/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.dropdowns.init());


App.dropdowns = {

  init() {
    return $(document)
      .off("click", ".dropdown-button", this.clicked)
      .on("click", ".dropdown-button", this.clicked);
  },


  clicked(evt) {
    const current = $(this).closest(".dropdown");
    const was_showing = current.find(".dropdown-menu").hasClass("show-menu");

    // Hide all others
    $(".dropdown-menu").removeClass("show-menu");

    current.find(".dropdown-menu")[was_showing ? "removeClass" : "addClass"]("show-menu");

    current.find(".dropdown-menu > li, .dropdown-close").click(() => current.find(".dropdown-menu").removeClass("show-menu"));

    return current.find(".dropdown-menu.dropdown-select > li").click(function() {
      const $item = $(this);

      current.find(".dropdown-button").html($item.html());

      const hidden_field = current.find(".js-dropdown-hidden-value");

      if (hidden_field[0]) {
        const value = $item[0].hasAttribute("data-value") ?
                  $item.attr("data-value")
                :
                  $item.text().trim().toLowerCase();

        hidden_field.val(value);
        return current.closest("form").submit();
      }
    });
  }
};
